<form [formGroup]="form">
    <app-checkbox-group formControlName="items" [multipleSelection]="multipleSelection" (change)="onValueChange()">
        <ng-container *ngFor="let item of data">
            <app-checkbox [value]="item[valueRef]" [label]="getLabel(item)"></app-checkbox>
        </ng-container>
    </app-checkbox-group>
</form>
